/** @jsxImportSource @emotion/react */
import { routes } from "../../appRoutingHelpers";
import { OrganizationKeyName } from "../../model/Organization";
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { ButtonInternalLink } from "../../components/NewButtons";
import { Table } from "../../components/table-components/Table";
import { TableRowHeader } from "../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../components/table-components/TableCellHeaderText";
import { TableBody } from "../../components/table-components/TableBody";
import { TableRow } from "../../components/table-components/TableRow";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";

export interface OrganizationBaseType {
  keyName: OrganizationKeyName;
  name: string;
}

export const OrganizationList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const allOrganizationsList: OrganizationBaseType[] = useSelector<
    RootState,
    OrganizationBaseType[]
  >(authSelectors.organizations);

  const isSuperAdmin = useSelector(authSelectors.isSuperAdmin);

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Organizations"
          subtitle="Edit or create new organizations"
        >
          {isSuperAdmin && (
            <ButtonInternalLink
              to={routes.organizationNew(organizationKeyName)}
            >
              Add new
            </ButtonInternalLink>
          )}
        </PageHeader>
        <Table>
          <thead>
            <TableRowHeader>
              <TableCellHeaderText>Name</TableCellHeaderText>
            </TableRowHeader>
          </thead>
          <TableBody>
            {allOrganizationsList.map((o, i) => {
              return (
                <TableRow key={i}>
                  <TableCellLink
                    isFirstTableCell={true}
                    href={routes.organizationEdit(
                      organizationKeyName,
                      o.keyName
                    )}
                  >
                    <StyledText
                      className="bodyTextRegular mb-0"
                      color={colors.textPrimary}
                    >
                      {o.name}
                    </StyledText>
                  </TableCellLink>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContainer>
    </PageWrapper>
  );
};

export default OrganizationList;
